define([], () => {

    // using deferred selectors as layout can be loaded while DOM hasn't rendered yet
    const Region = function (selector) {
        this.selector = selector;
    };

    _.extend(Region.prototype, {
        currentView: null,

        container () {

            // find element on every call, because container may be in dynamically updated component (Vue)
            return $(this.selector);
        },

        show (view, force) {
            if (view !== this.currentView || force === true) {
                this.close();

                if (view.open) {
                    view.open();
                }
                view.render();
                this.container().append(view.el);

                if (view.afterShow) {
                    view.afterShow();
                }

                this.currentView = view;
            }
            return this;
        },

        close () {
            const view = this.currentView;
            if (view) {
                if (view.close) {
                    view.close();
                }
                view.remove();
            }
            this.container().empty();
            this.currentView = null;
            return this;
        },

        spin () {
            const self = this;
            setTimeout(() => {
                if (!self.currentView) {
                    // new Spinner({color: '#333'}).spin(self.container().get(0));
                }
            }, 500);
            return this;
        },

        prepare () {
            return this.close().spin();
        }
    });

    return {
        breadcrumbs: new Region('#page-layout-topbar'),
        releaseNotes: new Region('#release-notes'),
        sidebar: new Region('#page-layout-sidebar'),
        quickstart: new Region('#user-quickstart'),
        tabs: new Region('#tabs'),
        header: new Region('#header'),
        content: new Region('#content'),
        outsourceRequest: new Region('#outsource-request'),
        pageScroller: new Region('#scroller')
    };
});
